import React from 'react'
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import recruiter_header_logo from "../basicInfoForm/images/logo_recruiter_header.png"
import "./expirylink.css"

const expirylink = () => {
    return (
        <>
            {/* HEADER */}
            <div className="nav_bg_home home-specific-header">
                <div className="container w1200 nav_bg_home_section">
                    <div className="nav_bg_left">
                        <li className="cp headerListStyleNone">
                            <span>
                                <img
                                    src={recruiter_header_logo}
                                    className="nav_logo_home"
                                    alt="logo"
                                />
                            </span>
                        </li>
                    </div>
                </div>
            </div>

            {/* EXPIRED CONTENT */}
            <div className="expired-page-wrapper">
                <div className="expired-card">
                    <div className="expired-icon">
                        <AccessTimeIcon className='clock_icon_expiry' />
                    </div>

                    <h2 className="expired-title">
                     This Scheduling Link Has Expired
                    </h2>

                    <p className="expired-subtitle">
                        This interview link has expired.<br />
                        Please contact the recruiter for a new link.
                    </p>
                </div>
            </div>


        </>
    )
}

export default expirylink